import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserNotificationsResponse } from 'app/layout/common/notifications/user-notifications/user-notification-types';

@Injectable({ providedIn: 'root' })
export class GetUserNotifications {
    private _httpClient = inject(HttpClient);

    execute(isPaginated: boolean = true, page: number = 1): Observable<UserNotificationsResponse> {
        let params = new HttpParams()
            .set('is_paginated', isPaginated.toString())
            .set('page', page.toString())
            .set('orderBy', 'id')
            .set('order', 'desc');

        return this._httpClient.get<UserNotificationsResponse>('api/notifications', { params, responseType: 'json' });
    }
}